import React from 'react';
import logo from '../assets/logito.png';

const Icon = {
  Whatsapp: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.263c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.485"/>
    </svg>
  ),
  Facebook: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  Email: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <path d="M22 6l-10 7L2 6"/>
    </svg>
  ),
  Phone: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
    </svg>
  ),
  Clock: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <circle cx="12" cy="12" r="10"/>
      <path d="M12 6v6l4 2"/>
    </svg>
  ),
  Arrow: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" {...props}>
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  ),
  Shield: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  ),
  Star: (props) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  ),
  Check: (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" {...props}>
      <path d="M20 6L9 17l-5-5"/>
    </svg>
  ),
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const sections = [
    {
      title: "Servicios",
      links: [
        { label: "Tesis de Pregrado", href: "/servicios/tesis-de-pregrado" },
        { label: "Tesis de Maestría", href: "/servicios/tesis-de-maestria" },
        { label: "Proyectos de Investigación", href: "/servicios/proyecto" },
        { label: "Revisión Sistemática", href: "/servicios/revision-sistematica" },
      ]
    },
    {
      title: "Empresa",
      links: [
        { label: "Sobre Nosotros", href: "/nosotros" },
        { label: "Garantías", href: "#garantias" },
        { label: "Preguntas Frecuentes", href: "#faq" },
        { label: "Contacto", href: "#contacto" },
      ]
    },
    {
      title: "Legal",
      links: [
        { label: "Términos de Servicio", href: "#terminos" },
        { label: "Política de Privacidad", href: "#privacidad" },
        { label: "Garantía Antiplagio", href: "#antiplagio" },
      ]
    },
  ];

  const features = [
    { icon: <Icon.Check />, label: "Garantía Antiplagio" },
    { icon: <Icon.Shield />, label: "Confidencialidad" },
    { icon: <Icon.Star />, label: "Expertos Verificados" },
    { icon: <Icon.Clock />, label: "Respuesta <4h" },
  ];

  return (
    <footer className="relative bg-gradient-to-b from-white via-[#FFF9C3]/20 to-[#FFF9C3]/40">
      {/* Decorative top border */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#fee017] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content */}
        <div className="py-12 sm:py-16">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
            {/* Brand Column - Más estrecho */}
            <div className="lg:col-span-4 space-y-6">
              {/* Logo & Brand */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FFF6B0] to-[#FFE55C] p-2 shadow-lg shadow-[#fee017]/30">
                  <img src={logo} alt="Tesis 1 Consultoria Logo" className="w-full h-full object-contain" />
                </div>
                <div>
                  <h3 className="text-2xl font-black text-gray-900">Tesis 1</h3>
                  <p className="text-xs font-bold bg-gradient-to-r from-[#c8b800] to-[#fee017] bg-clip-text text-transparent tracking-wider">
                    CONSULTORIA
                  </p>
                </div>
              </div>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed text-sm">
                Tu aliado confiable en el camino hacia tu tesis. Acompañamiento integral y profesional desde el primer contacto hasta la defensa final.
              </p>

              {/* Social Icons */}
              <div className="flex gap-3">
                <a 
                  href="https://wa.me/+51983318651" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 shadow-lg hover:shadow-xl hover:shadow-green-500/30 transition-all duration-300 hover:scale-110"
                >
                  <Icon.Whatsapp />
                </a>
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-xl hover:shadow-blue-600/30 transition-all duration-300 hover:scale-110"
                >
                  <Icon.Facebook />
                </a>
                <a 
                  href="mailto:info@tesis1.pe" 
                  className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-[#e1c800] to-[#fee017] text-gray-900 hover:from-[#c8b800] hover:to-[#e1c800] shadow-lg hover:shadow-xl hover:shadow-[#fee017]/30 transition-all duration-300 hover:scale-110"
                >
                  <Icon.Email />
                </a>
              </div>
            </div>

            {/* Links Columns - Más compacto */}
            <div className="lg:col-span-5 grid grid-cols-3 gap-6 sm:gap-8">
              {sections.map((section, idx) => (
                <div key={idx} className="space-y-4">
                  <h4 className="font-bold text-gray-900 text-sm uppercase tracking-wide">
                    {section.title}
                  </h4>
                  <ul className="space-y-2.5">
                    {section.links.map((link, lidx) => (
                      <li key={lidx}>
                        <a 
                          href={link.href} 
                          className="group inline-flex items-center gap-1.5 text-sm text-gray-600 hover:text-[#c8b800] transition-colors duration-200"
                        >
                          <span className="inline-block w-1 h-1 rounded-full bg-transparent group-hover:bg-[#fee017] transition-all"></span>
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Contact Column - Más estrecho */}
            <div className="lg:col-span-3 space-y-4">
              <h4 className="font-bold text-gray-900 text-sm uppercase tracking-wide">
                Contacto
              </h4>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-gradient-to-br from-[#FFF6B0] to-[#FFE55C] flex items-center justify-center text-[#c8b800]">
                    <Icon.Whatsapp className="w-4 h-4" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs font-semibold text-gray-900">WhatsApp</p>
                    <a href="https://wa.me/+51983318651" className="text-sm text-[#c8b800] hover:text-[#fee017] font-medium block truncate">
                      +51 983 318 651
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-gradient-to-br from-[#FFF6B0] to-[#FFE55C] flex items-center justify-center text-[#c8b800]">
                    <Icon.Email className="w-4 h-4" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs font-semibold text-gray-900">Email</p>
                    <a href="mailto:info@tesis1.pe" className="text-sm text-[#c8b800] hover:text-[#fee017] font-medium block truncate">
                      info@tesis1.pe
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-gradient-to-br from-[#FFF6B0] to-[#FFE55C] flex items-center justify-center text-[#c8b800]">
                    <Icon.Clock className="w-4 h-4" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-xs font-semibold text-gray-900">Horario</p>
                    <p className="text-sm text-gray-600">Lun - Dom 9:00 - 20:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section - Más compacto */}
        <div className="py-8 border-y border-[#fee017]/30">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {features.map((item, idx) => (
              <div 
                key={idx} 
                className="flex flex-col items-center text-center p-4 rounded-xl hover:bg-gradient-to-br hover:from-[#FFF9C3] hover:to-[#FFF6B0] transition-all duration-300 group"
              >
                <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#FFF6B0] to-[#FFE55C] flex items-center justify-center text-[#c8b800] mb-2 group-hover:scale-110 transition-transform">
                  {item.icon}
                </div>
                <p className="text-sm font-bold text-gray-900">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar - Más compacto */}
        <div className="py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-gray-600">
            <span className="font-medium">
              © {currentYear} Tesis1 Consultoría. Todos los derechos reservados.
            </span>
            <div className="flex items-center gap-2">
              <span>Hecho con</span>
              <span className="text-[#fee017] text-lg">♦</span>
              <span>para estudiantes</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}